// Faz 0 — Stok Tipi (SATIR bazlı sınıflandırma).
// Tek doğruluk kaynağı backend: DataScope.Entities/Enums/StockType.cs
//   Satilabilir = 0, Bedelsiz = 1, Depozito = 2, Hasarli = 3
// Aynı (depo, ürün) altında 4 ayrı havuz tutulur; toplam bakiye tiplerin SUM'ıdır.
// tone → PillTag tonu (default | success | danger | info)
export const STOCK_TYPES = [
  { value: 0, label: 'Satılabilir', tone: 'success' },
  { value: 1, label: 'Bedelsiz', tone: 'info' },
  { value: 2, label: 'Depozito', tone: 'default' },
  { value: 3, label: 'Hasarlı', tone: 'danger' },
];

export const STOCK_TYPE_OPTIONS = STOCK_TYPES.map((t) => ({ value: t.value, label: t.label }));

export const STOCK_TYPE_META = STOCK_TYPES.reduce((acc, t) => { acc[t.value] = t; return acc; }, {});

export function stockTypeLabel(value) {
  const v = Number(value);
  return STOCK_TYPE_META[v]?.label ?? (value == null || value === '' ? '-' : String(value));
}

/** Türkçe etiketten (import/Excel) enum değerine çevirir; eşleşmezse null. */
export function stockTypeFromLabel(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return null;
  const n = Number(s);
  if (Number.isInteger(n) && STOCK_TYPE_META[n]) return n;
  const norm = s.toLocaleLowerCase('tr');
  const found = STOCK_TYPES.find((t) => t.label.toLocaleLowerCase('tr') === norm);
  return found ? found.value : null;
}

// vw_StockBalance kolaylık kolonları (tip kırılımı — satır sayısını DEĞİŞTİRMEZ).
// Tip toplamı görünümünde (varsayılan) tek satırda kırılım rozetleri için kullanılır.
export const BALANCE_TYPE_FIELDS = [
  { value: 0, field: 'physicalSellable' },
  { value: 1, field: 'physicalFree' },
  { value: 2, field: 'physicalDeposit' },
  { value: 3, field: 'physicalDamaged' },
];

export const BALANCE_TYPE_ODATA_FIELDS = ['PhysicalSellable', 'PhysicalFree', 'PhysicalDeposit', 'PhysicalDamaged'];
